import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useCurrentConsignment() {
  const consignmentKey = useParams<'consignmentKey'>().consignmentKey as string

  return useSuspenseQuery({
    ...apiClient.getConsignmentConsignmentsKeyGetOptions({
      path: {
        key: consignmentKey,
      },
    }),
    staleTime: 1000 * 60,
  })
}
